import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import { GET_FILES, DELETE_FILES, DOWNLOAD_FILES } from './actionType';

import { FilesApiResponseError, FilesApiResponseSuccess } from './action';

import {
  getFiles as filesGet,
  deleteFiles as filesDelete,
  downloadFiles as filesDownload,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getFiles({ payload }) {
  try {
    const response = yield call(filesGet, payload.id);
    yield put(FilesApiResponseSuccess(GET_FILES, response));
  } catch (error) {
    yield put(FilesApiResponseError(GET_FILES, error));
  }
}

function* deleteFiles({ payload }) {
  try {
    const response = yield call(filesDelete, payload.path);
    yield put(FilesApiResponseSuccess(DELETE_FILES, response));
    notifySuccess('Arquivo deletado com sucesso!');
  } catch (error) {
    yield put(FilesApiResponseError(DELETE_FILES, error));
    notifyError('Erro ao deletar arquivo!');
  }
}

function* downloadFiles({ payload }) {
  try {
    const response = yield call(filesDownload, payload.path);
    yield put(FilesApiResponseSuccess(DOWNLOAD_FILES, response));
    notifySuccess('Arquivo baixado com sucesso!');
  } catch (error) {
    yield put(FilesApiResponseError(DOWNLOAD_FILES, error));
    notifyError('Erro ao baixar arquivo!');
  }
}

export function* watchGetFiles() {
  yield takeEvery(GET_FILES, getFiles);
}

export function* watchDeleteFiles() {
  yield takeEvery(DELETE_FILES, deleteFiles);
}

export function* watchDownloadFiles() {
  yield takeEvery(DOWNLOAD_FILES, downloadFiles);
}

function* FilesSaga() {
  yield all([fork(watchGetFiles)]);
  yield all([fork(watchDeleteFiles)]);
  yield all([fork(watchDownloadFiles)]);
}

export default FilesSaga;
